<template>
  <div>
    <h1>Show {{ item && item['@id'] }}</h1>

    <div
      v-if="isLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ error }}
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ deleteError }}
    </div>
    <div
      v-if="item"
      class="table-responsive">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Field</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>state</td>
            <td>{{ item['state'] }}</td>
          </tr>
          <tr>
            <td>createdAt</td>
            <td>{{ item['createdAt'] }}</td>
          </tr>
          <tr>
            <td>updatedAt</td>
            <td>{{ item['updatedAt'] }}</td>
          </tr>
          <tr>
            <td>deletedAt</td>
            <td>{{ item['deletedAt'] }}</td>
          </tr>
          <tr>
            <td>createdBy</td>
            <td>{{ item['createdBy'] }}</td>
          </tr>
          <tr>
            <td>updatedBy</td>
            <td>{{ item['updatedBy'] }}</td>
          </tr>
          <tr>
            <td>deletedBy</td>
            <td>{{ item['deletedBy'] }}</td>
          </tr>
          <tr>
            <td>dailyPlan</td>
            <td>{{ item['dailyPlan'] }}</td>
          </tr>
          <tr>
            <td>timeStart</td>
            <td>{{ item['timeStart'] }}</td>
          </tr>
          <tr>
            <td>timeStop</td>
            <td>{{ item['timeStop'] }}</td>
          </tr>
          <tr>
            <td>task</td>
            <td>{{ item['task'] }}</td>
          </tr>
          <tr>
            <td>order</td>
            <td>{{ item['order'] }}</td>
          </tr>
          <tr>
            <td>type</td>
            <td>{{ item['type'] }}</td>
          </tr>
          <tr>
            <td>distance</td>
            <td>{{ item['distance'] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <router-link
      v-if="item"
      :to="{ name: 'EXCMDailyPlanItemList' }"
      class="btn btn-default">Back to list</router-link>
    <button
      class="btn btn-danger"
      @click="deleteItem(item)">Delete</button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: mapGetters({
    deleteError: 'excmdailyplanitem/del/error',
    error: 'excmdailyplanitem/show/error',
    isLoading: 'excmdailyplanitem/show/isLoading',
    item: 'excmdailyplanitem/show/retrieved'
  }),

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      del: 'excmdailyplanitem/del/del',
      reset: 'excmdailyplanitem/show/reset',
      retrieve: 'excmdailyplanitem/show/retrieve'
    }),

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'EXCMDailyPlanItemList' }))
      }
    }
  }
}
</script>
